<template>
  <div
    class="fleet-item-palette w-full absolute left-0 floating-panel z-10 flex flex-col"
    v-show="itemTypes != null"
    :style="{ top: posY + 'px' }"
    @mousedown="onPointerDown"
    @touchstart="onPointerDown"
  >
    <input
      ref="searchInput"
      type="text"
      @input="onSearch"
      class="flex-0 w-full h-8 bg-input mb-2"
      :placeholder="$t('components.item_type_palette.placeholder')"
    />
    <div
      v-if="itemTypes != null"
      class="flex-1 w-full h-full flex flex-row flex-wrap overflow-y-auto"
      style="max-height: 30rem;"
    >
      <button
        v-if="allowNull"
        @click="onNullSelected()"
        class="palette-item relative w-12 h-12"
      >
        <img src="" alt="" />
      </button>
      <button
        :key="itemType.key"
        v-for="itemType of itemTypes.filter(
          t => t.name.toLowerCase().indexOf(search.toLowerCase()) >= 0
        )"
        :title="itemType.name"
        @click="onItemTypeSelected(itemType)"
        class="palette-item relative w-12 h-12"
        :class="{
          selected: itemType.key === selected,
          'glow-blue': itemType.key === selected
        }"
      >
        <img v-bind:src="itemType.image" :alt="itemType.name" />
      </button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "FleetItemPalette",
  props: {
    selectionBus: {
      type: Vue,
      required: true
    },
    showRemoveButton: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      itemTypes: null,
      selected: null,
      allowNull: false,
      search: "",
      posY: 0
    };
  },
  created() {
    this.selectionBus.$on("show", this.onSelectionRequested);
    document.body.addEventListener("mousedown", this.onGlobalPointerDown);
    document.body.addEventListener("touchstart", this.onGlobalPointerDown);
  },
  destroyed() {
    document.body.removeEventListener("mousedown", this.onGlobalPointerDown);
    document.body.removeEventListener("touchstart", this.onGlobalPointerDown);
  },
  methods: {
    onSelectionRequested(event) {
      if (this.itemTypes != null) {
        this.onGlobalPointerDown();
      }
      this.itemTypes = Object.values(event.itemTypes);
      this.selected = event.selected;
      this.allowNull = event.allowNull;
      this.posY = event.posY || 0;
      this.search = "";

      const searchInput = this.$refs["searchInput"];
      setTimeout(() => {
        searchInput.focus();
        searchInput.select();
      }, 1);
    },
    onSearch(event) {
      this.search = event.target.value;
    },
    onItemTypeSelected(itemType) {
      this.selectionBus.$emit("select", itemType);
      this.itemTypes = null;
      this.selected = null;
    },
    onNullSelected() {
      this.onItemTypeSelected(null);
    },
    onPointerDown(event) {
      event.stopPropagation();
    },
    onGlobalPointerDown() {
      if (this.itemTypes == null) return;
      this.selectionBus.$emit("cancel");
      this.itemTypes = null;
      this.selected = null;
    }
  }
};
</script>

<style scoped>
.fleet-item-palette {
  padding: 1rem;
  box-sizing: border-box;
  border: var(--border-reg);
}
#app.mouse .palette-item:hover {
  cursor: pointer;
  box-shadow: var(--glow-outer-white);
}
.selected,
#app.mouse .palette-item:hover {
  z-index: 1;
}
#app.mouse .palette-item.selected::after,
#app.mouse .palette-item:hover::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
#app.mouse .palette-item.selected::after {
  box-shadow: var(--glow-inner-blue);
}
#app.mouse .palette-item:hover::after {
  box-shadow: var(--glow-inner-white);
}
</style>
